"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var json_logic_js_1 = __importDefault(require("json-logic-js"));
exports.jsonLogic = json_logic_js_1.default;
var date_fns_1 = require("date-fns");
var notEmpty_1 = require("./operations/notEmpty");
var noneIn_1 = require("./operations/noneIn");
var someIn_1 = require("./operations/someIn");
json_logic_js_1.default.add_operation("not_empty", notEmpty_1.notEmpty);
json_logic_js_1.default.add_operation("none_in", noneIn_1.noneIn);
json_logic_js_1.default.add_operation("some_in", someIn_1.someIn);
// Date related operations
// Simple array can not be used since names of functions are then minified
Object.entries({
    addDays: date_fns_1.addDays,
    addMonths: date_fns_1.addMonths,
    addWeeks: date_fns_1.addWeeks,
    addYears: date_fns_1.addYears,
    differenceInDays: date_fns_1.differenceInDays,
    differenceInMonths: date_fns_1.differenceInMonths,
    differenceInWeeks: date_fns_1.differenceInWeeks,
    differenceInYears: date_fns_1.differenceInYears,
    format: date_fns_1.format,
    getDate: date_fns_1.getDate,
    isAfter: date_fns_1.isAfter,
    isBefore: date_fns_1.isBefore,
    isSameDay: date_fns_1.isSameDay,
    parseISO: date_fns_1.parseISO,
    setDate: date_fns_1.setDate,
    startOfDay: date_fns_1.startOfDay,
    startOfMonth: date_fns_1.startOfMonth,
    startOfToday: date_fns_1.startOfToday,
    isEqual: date_fns_1.isEqual,
}).forEach(function (_a) {
    var name = _a[0], dateOperation = _a[1];
    json_logic_js_1.default.add_operation(name, dateOperation);
});
